import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { Alert, App, Form, Input, Spin, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import {
  confirmEmail as confirmEmailAction,
  confirmClear as confirmClearAction,
  confirmErrorClear as confirmErrorClearAction,
  ConfirmEmailAction,
} from "@triare/auth-redux/dist/saga/auth/confirm";
import { Action } from "@triare/auth-redux";
import Wrapper from "../Wrapper";
import { getMessageInError } from "../../../../hooks/fetch";
import {
  createRulesForAntd,
  validationNewPassword,
} from "../../../../utils/validations";
import Submit from "../../../Common/Form/Button/Submit";
import { useAuth } from "../../../../store/auth";
import OTPCode from "../SignUp/OTPCode";

const validationRules = createRulesForAntd(validationNewPassword);

export interface ConfirmEmailProps {
  mode?: string;
  confirmEmail: (payload: ConfirmEmailAction) => Action<ConfirmEmailAction>;
  confirmClear: () => Action;
  confirmErrorClear: () => Action;
}

function ConfirmEmail({
  mode: modeParam,
  confirmEmail,
  confirmErrorClear,
  confirmClear,
}: ConfirmEmailProps): React.ReactNode {
  const {
    confirm: { response, loading, error },
    user,
  } = useAuth();
  const { t } = useTranslation();
  const { message } = App.useApp();

  // Both error alerts on this screen became the platform's message toast, the
  // channel the rest of the app uses for a failed request. Cleared once shown,
  // as useMessageError does, so a stale error cannot surface on a re-entry.
  useEffect(() => {
    if (error) {
      message.error(getMessageInError(error));
      confirmErrorClear();
    }
  }, [error]);
  const { mode = modeParam, secretKey } = useParams();
  const navigate = useNavigate();
  const [redirect, setRedirect] = useState(false);

  useEffect(() => {
    if (secretKey && mode === "none") {
      confirmEmail({
        secretKey,
      });
    }
  }, [secretKey]);

  useEffect(() => {
    if (!loading && !error) {
      if (response) {
        setRedirect(true);
      } else if (redirect) {
        if (user && user.settings && !user.settings.isPhoneVerified) {
          console.log("bla");
        } else {
          navigate("/");
        }
      }
    }
  }, [response, error, loading, redirect, user]);

  if (user && user.email) {
    return (
      <Wrapper>
        <OTPCode onBack={() => navigate("/")} />
      </Wrapper>
    );
  }

  if (mode === "password") {
    return (
      <Wrapper>
        <Typography.Title level={3} style={{ textAlign: "center" }}>
          Email confirmation!
        </Typography.Title>

        <div style={{ padding: "16px 32px", textAlign: "center" }}>
          In order to complete your sign-up process, please enter your password.
        </div>

        <Form
          layout="vertical"
          scrollToFirstError
          onFinish={({ password }) => {
            confirmEmail({
              secretKey: secretKey || "",
              password,
            });
          }}
        >
          <Form.Item
            name="password"
            required
            label={t("password")}
            rules={[validationRules]}
          >
            <Input.Password placeholder="Password" size="large" />
          </Form.Item>

          {response && !error ? (
            <Alert
              type="success"
              message="Signed in successfully!"
              style={{ margin: "8px 0 24px" }}
              closable
              onClose={() => confirmClear()}
            />
          ) : null}

          <Submit size="large">Confirm</Submit>
        </Form>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <Typography.Title level={3} style={{ textAlign: "center" }}>
        Your email confirm {}
        {error ? "" : response || redirect ? "successfully!" : <Spin />}
      </Typography.Title>
    </Wrapper>
  );
}

export default connect(null, {
  confirmEmail: confirmEmailAction,
  confirmClear: confirmClearAction,
  confirmErrorClear: confirmErrorClearAction,
})(ConfirmEmail);
